import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IPartLookupResponse } from "../models/PartLookup";
import apiConfig from "../utils/apiConfig";

export default function usePartsLeadLookup(leadId?: string, vehicleId?: string, requestId?: string | null | undefined, componentName = "usePartsLeadLookup") {
  const { get, post, put } = useApiHelper(apiConfig(componentName));
  const queryClient = useQueryClient();
  const staleTime = 1000 * 60 * 60 * 1; //1 hour

  const lookup = useQuery({
    queryKey: ["partslookup", { "lead": leadId }, { "vehicle": vehicleId }],
    queryFn: () => get<IPartLookupResponse>(`/partlookup/lookup?${leadId ? `leadId=${leadId}` : ""}${vehicleId ? `&vehicleId=${vehicleId}` : ""}`),
    staleTime: staleTime,
    cacheTime: staleTime * 2,
    retry: 1,
    enabled: !!requestId,
  });

  const lookupMutation = useMutation(
    () => get<IPartLookupResponse>(`/partlookup/lookup?${leadId ? `leadId=${leadId}` : ""}${vehicleId ? `&vehicleId=${vehicleId}` : ""}&ignoreLookupId=true`),
    {
      onSuccess: (data) => {
        queryClient.setQueryData(["partslookup"], data);

        //remove local cache of brand before invalidating
        localStorage.removeItem("customerBrand");
        localStorage.removeItem("customerBrandExp");

        queryClient.refetchQueries(["parts", "multiple"]);
        queryClient.refetchQueries(["customer", "brand"]);
        queryClient.refetchQueries(["lead"]);
        queryClient.refetchQueries(["vehicles"]);
        queryClient.refetchQueries(["parts"]);
      },
    }
  );

  return {
    lookup,
    lookupMutation
  };
}
